var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBottomWeb = function SvgIconBottomWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 14,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECF2",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.011 27.41h7.022c.134-5.618 2.19-10.249 5.515-14.21-6.93 1.139-12.259 7.027-12.537 14.21ZM28 13.444c-3.619 3.898-5.821 8.405-5.967 13.966h11.934C33.82 21.85 31.619 17.342 28 13.444Zm5.93 15.966H22.07c.332 5.118 2.48 9.062 5.93 12.74 3.45-3.678 5.598-7.622 5.93-12.74Zm-7.99 13.45c-3.375-3.793-5.553-8.019-5.873-13.45h-7.002c.648 6.94 6.023 12.508 12.874 13.45Zm4.12 0c3.375-3.793 5.553-8.019 5.873-13.45h7.002c-.648 6.94-6.023 12.508-12.874 13.45ZM28.01 45C37.394 44.995 45 37.386 45 28c0-9.389-7.611-17-17-17s-17 7.611-17 17c0 9.386 7.606 16.995 16.991 17l.009.009.009-.009Zm14.98-17.59h-7.022c-.134-5.618-2.19-10.249-5.515-14.21 6.93 1.139 12.259 7.027 12.537 14.21Z",
    fill: "#A4A7AD"
  })));
};
export default SvgIconBottomWeb;